/** Minimal review shape needed for date sorting. */
export interface SortableReview {
  date?: string | null;
}

/** Parse a review date to epoch ms; missing/invalid dates sort last. */
function reviewDateMs(date: string | null | undefined): number {
  if (!date) return 0;
  const ms = new Date(date).getTime();
  return Number.isFinite(ms) ? ms : 0;
}

/** Newest reviews first. Returns a new array; does not mutate the input. */
export function sortReviewsByMostRecent<T extends SortableReview>(reviews: T[]): T[] {
  return [...reviews].sort((a, b) => reviewDateMs(b.date) - reviewDateMs(a.date));
}
